// import library
import axios from "axios";
import { useParams } from "react-router";
import { useEffect, useState } from "react";
// import files
import { env } from "../../env";
// common components
import OrderAgainBasic from "../../components/Order/Customer/OrderAgainBasic";
import OrderAgainWithPrice from "../../components/Order/Customer/OrderAgainWithPrice";

const OrderAgain = () => {
    // variables
    const {customerid} = useParams();
    const baseUrl = env.REACT_APP_API_URL;
    const token = localStorage.getItem('token');
    const [customerData, setCustomerData] = useState({});

    // functions
    useEffect(() => {
        const fetchData = async () => {
            try {
                if (customerid) {
                    await Promise.all([
                        getCustomerDataApi(baseUrl, token),
                    ]);
                }
            } catch (error) {
                console.error("Error fetching data", error);
            }
        };
    
        fetchData();
    }, [customerid, baseUrl, token]);

    // api
    const getCustomerDataApi = async (url, token) => {
        axios.post(url + "/api/Customer/GetCustomerDetail", { customerid: customerid }, {
            headers: {
                "Content-Type": "multipart/form-data",
                "Authorization": `Bearer ${token}`
            }
        }).then(response => {
            if (response.data.length > 0) {
                setCustomerData(response.data[0]);
            }
        }).catch((error) => {
            console.log(error);
            if(error.response && (error.response.status === 401 || error.response.status === 404)) {
                localStorage.removeItem("token");
                localStorage.removeItem("userInfo");
                window.location.reload();
            }
        })
    };

    return (
        <>
            {customerData.showPrices 
                ? 
                    <OrderAgainWithPrice />
                :
                    <OrderAgainBasic />
            }
        </>
    )
}

export default OrderAgain;